module.exports = [{"ID":"1","value":17,"text":"17%","visivel":true},{"ID":"2","value":25,"text":"25%","visivel":true}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/arquivos/aliq_acre.json
// module id = ouai
// module chunks = 1